/// <reference path="../../../../tools/typings/tsd.d.ts"/>
/// <reference path="../../content.ts"/>

module DealerwareWebContent {
    "use strict";
    import IDealerwareContract = DealerwareWebServices.IDealerwareContract;

    var isFunction = angular.isFunction;

    export interface IContractDetailsController {
        contractId: number;
        contract: IDealerwareContract;
        insuranceLoaded: boolean;
        contractLoaded: boolean;
        postLoadTabData: boolean;

        loadContract(id: number) : void;
        loadDriversLicense() : void;
        loadAdditionalDrivers() : void;
        loadInsurance() : void;
        saveInsurance(record: any, deleteInsuranceImage: boolean) : ng.IPromise<{}>;
        notesShown() : void;
        loadVehicles() : void;
        loadVehicleIssues() : void;
        loadPricingSection() : void;
    }

    export class ContractDetailsController implements IContractDetailsController {
        public static $inject: string[] = [
            '$q',
            '$stateParams',
            '$mobilityCompanyAuthentication',
            '$dealerwareLoading',
            'LocationModel',
            '$dealerwareNotification',
            '$dealerwareContractFactory',
            'DealerwareCreditCardCollection',
            'routeShortcuts',
            'DataUtils',
            'reverseRouteShortcuts',
            '$state',
            '$rootScope',
            '$timeout',
            '$dealerwareInternationalizationData'
        ];

        public contractId: number;
        public contract: any;
        public insuranceLoaded: boolean = false;
        public contractLoaded: boolean = false;
        public postLoadTabData: boolean = false;
        public labels: {};

        constructor(public $q: any,
                    public $stateParams: any,
                    public $auth: any,
                    public $dealerwareLoading: any,
                    public LocationModel: any,
                    public $dealerwareNotification: any,
                    public $dealerwareContractFactory: any,
                    public DealerwareCreditCardCollection: any,
                    public routeShortcuts: any,
                    public DataUtils: any,
                    public reverseRouteShortcuts: any,
                    public $state: any,
                    public $rootScope: any,
                    public $timeout: any,
                    public $dealerwareInternationalizationData: any) {
            this.getLabels('contracts');
            this.loadContract(this.$stateParams.contractId);
            this.contractId = this.$stateParams.contractId;
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function(error: any) {
                    _self.$dealerwareNotification(error);
                }
            );
        }

        public isDetailsPage () : boolean {
            return this.$state.current.url.match(/details/) !== null;
        }

        public isDriversLicensePage () : boolean {
            return this.$state.current.url.match(/drivers\-license/) !== null;
        }

        public isAdditionalDriversPage () : boolean {
            return this.$state.current.url.match(/additional\-driver/) !== null;
        }

        public isInsurancePage () : boolean {
            return this.$state.current.url.match(/insurance/) !== null;
        }

        public isNotesPage () : boolean {
            return this.$state.current.url.match(/notes/) !== null;
        }

        public isVehiclesPage () : boolean {
            return this.$state.current.url.match(/vehicles/) !== null;
        }

        public isPricingPage () : boolean {
            return this.$state.current.url.match(/pricing/) !== null;
        }

        public isVehicleIssuesPage () : boolean {
            return this.$state.current.url.match(/vehicle\-issues/) !== null;
        }

        public transitionToDetails () : void {
            this.$state.go (
                this.routeShortcuts['contractDetails'].target,
                { contract_id: this.$stateParams.contractId }
            );
        }

        public transitionToDriversLicense () : void {
            this.$state.go (
                this.routeShortcuts['contractDriversLicense'].target,
                { contract_id: this.$stateParams.contractId }
            );
        }

        public transitionToAdditionalDrivers () : void {
            this.$state.go (
                this.routeShortcuts['contractAdditionalDrivers'].target,
                { contract_id: this.$stateParams.contractId }
            );
        }

        public transitionToInsurance () : void {
            this.$state.go (
                this.routeShortcuts['contractInsurance'].target,
                { contract_id: this.$stateParams.contractId }
            );
        }

        public transitionToNotes () : void {
            this.$state.go (
                this.routeShortcuts['contractNotes'].target,
                { contract_id: this.$stateParams.contractId }
            );
        }

        public transitionToVehicles () : void {
            this.$state.go (
                this.routeShortcuts['contractVehicles'].target,
                { contract_id: this.$stateParams.contractId }
            );
        }

        public transitionToPricing () : void {
            this.$state.go (
                this.routeShortcuts['contractPricing'].target,
                { contract_id: this.$stateParams.contractId }
            );
        }

        public transitionToVehicleIssues () : void {
            this.$state.go (
                this.routeShortcuts['contractVehicleIssues'].target,
                { contract_id: this.$stateParams.contractId }
            );
        }

        public loadContract(id: number) : void {
            if (id) {
                var loader = this.$dealerwareLoading.show('Loading Contract...');
                this.$dealerwareContractFactory.loadContract(this.$auth.location.id, id).then(
                    (response: any) => {
                        this.contract = response.contract;
                        this.contract.isDms = !this.DataUtils.getInstance().isBlank(this.$auth.location.settings.dms_provider);
                        this.contractLoaded = true;
                        return this.loadWarranty();
                    },
                    (response: any) => { this.$dealerwareNotification.apiError(response); }
                ).then(
                    () => {
                        if (this.postLoadTabData) {
                            switch(this.reverseRouteShortcuts[this.$state.current.name]) {
                                case 'contractDriversLicense':
                                    return this.loadDriversLicense();
                                case 'contractAdditionalDrivers':
                                    return this.loadAdditionalDrivers();
                                case 'contractInsurance':
                                    return this.loadInsurance();
                                case 'contractNotes':
                                    return this.notesShown();
                                case 'contractVehicles':
                                    return this.loadVehicles();
                                case 'contractPricing':
                                    return this.loadPricingSection();
                                case 'contractVehicleIssues':
                                    return this.loadVehicleIssues();
                            }
                        }
                    }
                ).finally(() => { loader.close(); })
            } else {
                this.$dealerwareNotification.error("No contract to load");
            }
        }

        public loadWarranty() : void {
            if (this.contractLoaded && !this.contract.warranty) {
                return this.contract.loadWarranty();
            }

            return this.$q.when();
        }

        public loadDriversLicense() : void {
            var _self = this;

            if (this.contractLoaded && ! this.contract.driversLicense) {
                var loader = this.$dealerwareLoading.show('Loading Drivers License...');
                return this.contract.loadDriversLicense().then().finally(
                    function() { loader.close(); }
                );
            } else {
                this.postLoadTabData = true;
            }

            return this.$q.when();
        }

        public loadAdditionalDrivers() : void {

            if (this.contractLoaded && ! this.contract.additionalDrivers) {
                var loader = this.$dealerwareLoading.show('Loading Additional Driver(s)...');
                return this.contract.loadAdditionalDrivers().then().finally(
                    function() { loader.close(); }
                );
            } else {
                this.postLoadTabData = true;
            }

            return this.$q.when();
        }

        public loadInsurance() : void {
            var _self = this;

            if (this.contractLoaded && ! this.insuranceLoaded) {
                var loader = this.$dealerwareLoading.show('Loading Insurance...');
                this.$q.all([
                    this.contract.loadInsurance(),
                    this.contract.loadInsuranceImage()
                ]).finally(() => {
                    _self.insuranceLoaded = true;
                    loader.close();
                });
            } else {
                this.postLoadTabData = true;
            }
        }

        public saveInsurance(record: any, deleteInsuranceImage: boolean) : ng.IPromise<{}> {
            var _deferred = this.$q.defer(),
                _self = this;

            var loader = this.$dealerwareLoading.show('Saving...');
            this.contract.contractDetails.data.reservation_insurances_mapped = record;
            this.contract.contractDetails.$saveInsurance({
                promise: true,
                params: { location_id: this.contract.locationId }
            }).then(
                function(response: any) {
                    if (deleteInsuranceImage && _self.contract.insuranceImage && _self.contract.insuranceImage.data) {
                        _self.contract.deleteInsuranceImage().finally(function() {
                            loader.close();
                            _self.$dealerwareNotification.toast('Insurance saved!');
                            _deferred.resolve();
                        });
                    } else {
                        loader.close();
                        _self.$dealerwareNotification.toast('Insurance saved!');
                        _deferred.resolve();
                    }
                },
                function(response: any) {
                    loader.close();
                    _self.$dealerwareNotification.apiError(response);
                    _deferred.reject();
                }
            );

            return _deferred.promise;
        }

        public notesShown() : void {
            var _self = this;

            if (this.contractLoaded && _self.contract.noteCollection && ! _self.contract.noteCollection.isNotesLoaded()) {
                var loader = _self.$dealerwareLoading.show("Loading notes...");
                return _self.contract.loadNotes().then().finally(
                    function() { loader.close(); }
                );
            } else {
                this.postLoadTabData = true;
            }

            return this.$q.when();
        }

        public loadVehicles() : void {
            var _self = this;

            if (this.contractLoaded && ! this.contract.vehicles) {
                var loader = this.$dealerwareLoading.show('Loading...');
                return this.contract.loadVehicleContracts().then().finally(
                    function() { loader.close(); }
                );
            } else {
                this.postLoadTabData = true;
            }

            return this.$q.when();
        }

        public loadVehicleIssues() : void {
            var _self = this;

            if (this.contractLoaded && ! this.contract.vehicleIssues) {
                var loader = this.$dealerwareLoading.show('Loading...');
                return this.contract.loadVehicleIssues().then().finally(
                    function() { loader.close(); }
                );
            } else {
                this.postLoadTabData = true;
            }

            return this.$q.when();
        }

        public loadPricingSection() : void {
            if (this.contractLoaded) {
                var loader = this.$dealerwareLoading.show('Loading...');
                return this.contract.loadCurrentInvoice().finally(() => {
                    loader.close();
                });
            } else {
                this.postLoadTabData = true;
            }

            return this.$q.when();
        }
    }

    getDealerwareWebContentModule().controller('ContractDetailsController', ContractDetailsController);
}
